import React, { lazy, Suspense } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { OverlayProvider, Spinner } from '@ui'
import { BlankLayout } from '../layouts'
import PrivateRoute from './PrivateRoute'
import { GlobalStyling } from '../styles'

const HomePageComponent = lazy(() => import('../pages/homePages'))
const ProfileComponent = lazy(() => import('../pages/brandProfilePages'))
const CampaignListComponent = lazy(() => import('../pages/campaignListPages'))
const CampaignEditComponent = lazy(() => import('../pages/campaignEditPages'))
const InsightsComponent = lazy(() => import('../pages/insightPages'))
const SettingsComponent = lazy(() => import('../pages/settingsPages'))
const FinanceComponent = lazy(() => import('../pages/financePages'))
const SystemSettingsComponent = lazy(() => import('../pages/systemSettingsPages'))
const LoginComponent = lazy(() => import('../pages/authPages/LoginPage'))
const RegistrationComponent = lazy(() => import('../pages/authPages/RegistrationPage'))
const ResetPasswordComponent = lazy(() => import('../pages/authPages/ResetPasswordPage'))
const GoogleCallbackComponent = lazy(() => import('../pages/authPages/LoginGoogleCallbackPage'))
const GoogleLoginComponent = lazy(() => import('../pages/authPages/LoginGooglePage'))
const LogoutComponent = lazy(() => import('../pages/authPages/LogoutPage'))
const TermsComponent = lazy(() => import('../pages/termsPages'))
const PaymentsOverviewComponent = lazy(() => import('../pages/paymentsPages/PaymentsOverviewPage'))
const UpdatePaymentComponent = lazy(() => import('../pages/paymentsPages/UpdatePaymentPage'))
const UserAccountComponent = lazy(() => import('../pages/userAccountPages'))
const AdvancedSettingsComponent = lazy(() => import('../pages/advancedSettingsPages'))

const HomePage = () => (
	<Suspense fallback={<Spinner />}>
		<HomePageComponent />
	</Suspense>
)
const BrandProfilePage = () => (
	<Suspense fallback={<Spinner />}>
		<ProfileComponent />
	</Suspense>
)
const CampaignListPage = () => (
	<Suspense fallback={<Spinner />}>
		<CampaignListComponent />
	</Suspense>
)
const CampaignEditPage = () => (
	<Suspense fallback={<Spinner />}>
		<CampaignEditComponent />
	</Suspense>
)
const InsightsPage = () => (
	<Suspense fallback={<Spinner />}>
		<InsightsComponent />
	</Suspense>
)
const PaymentsOverviewPage = () => (
	<Suspense fallback={<Spinner />}>
		<PaymentsOverviewComponent />
	</Suspense>
)
const UpdatePaymentPage = () => (
	<Suspense fallback={<Spinner />}>
		<UpdatePaymentComponent />
	</Suspense>
)
const SettingsPage = () => (
	<Suspense fallback={<Spinner />}>
		<SettingsComponent />
	</Suspense>
)
const FinancePage = () => (
	<Suspense fallback={<Spinner />}>
		<FinanceComponent />
	</Suspense>
)
const UserAccountPage = () => (
	<Suspense fallback={<Spinner />}>
		<UserAccountComponent />
	</Suspense>
)

const SystemSettingsPage = () => (
	<Suspense fallback={<Spinner />}>
		<SystemSettingsComponent />
	</Suspense>
)

const AdvancedSettingsPage = () => (
	<Suspense fallback={<Spinner />}>
		<AdvancedSettingsComponent />
	</Suspense>
)

const LoginPage = () => (
	<Suspense fallback={<Spinner />}>
		<BlankLayout>
			<LoginComponent />
		</BlankLayout>
	</Suspense>
)

const RegistrationPage = () => (
	<Suspense fallback={<Spinner />}>
		<BlankLayout>
			<RegistrationComponent />
		</BlankLayout>
	</Suspense>
)
const ResetPasswordPage = () => (
	<Suspense fallback={<Spinner />}>
		<BlankLayout>
			<ResetPasswordComponent />
		</BlankLayout>
	</Suspense>
)
const LogoutPage = () => (
	<Suspense fallback={<Spinner />}>
		<BlankLayout>
			<LogoutComponent />
		</BlankLayout>
	</Suspense>
)
const GoogleLoginPage = () => (
	<Suspense fallback={<Spinner />}>
		<BlankLayout>
			<GoogleLoginComponent />
		</BlankLayout>
	</Suspense>
)
const GoogleCallbackPage = () => (
	<Suspense fallback={<Spinner />}>
		<BlankLayout>
			<GoogleCallbackComponent />
		</BlankLayout>
	</Suspense>
)
const TermsPage = () => (
	<Suspense fallback={<Spinner />}>
		<TermsComponent />
	</Suspense>
)

export default () => (
	<BrowserRouter>
		<OverlayProvider outletId="modal" />
		<GlobalStyling />
		<Routes>
			<Route path="/" element={<PrivateRoute layout="AppLayout" element={<HomePage />} />} />
			<Route path="/brand-profile" element={<PrivateRoute layout="AppLayout" element={<BrandProfilePage />} />} />
			{/* TODO: merge the two following lines */}
			<Route path="/campaigns" element={<PrivateRoute layout="AppLayout" element={<CampaignListPage />} />} />
			<Route path="/campaigns/:action" element={<PrivateRoute layout="AppLayout" element={<CampaignEditPage />} />} />
			<Route
				path="/campaigns/:action/:campaignId"
				element={<PrivateRoute layout="AppLayout" element={<CampaignEditPage />} />}
			/>
			<Route path="/insights" element={<PrivateRoute layout="AppLayout" element={<InsightsPage />} />} />
			<Route path="/payments/update" element={<PrivateRoute layout="AppLayout" element={<UpdatePaymentPage />} />} />
			<Route path="/payments" element={<PrivateRoute layout="AppLayout" element={<PaymentsOverviewPage />} />} />
			<Route path="/settings" element={<PrivateRoute layout="AppLayout" element={<SettingsPage />} />} />
			<Route path="/settings/:tab" element={<PrivateRoute layout="AppLayout" element={<SettingsPage />} />} />
			<Route path="/finance" element={<PrivateRoute layout="AppLayout" element={<FinancePage />} />} />
			<Route
				path="/system-settings"
				element={<PrivateRoute layout="AppLayout" element={<SystemSettingsPage />} />}
			/>
			<Route
				path="/system-settings/:tab"
				element={<PrivateRoute layout="AppLayout" element={<SystemSettingsPage />} />}
			/>
			<Route
					path="/advanced-settings"
					element={<PrivateRoute layout="AppLayout" element={<AdvancedSettingsPage />} />}
				/>
				<Route
					path="/advanced-settings/:tab"
					element={<PrivateRoute layout="AppLayout" element={<AdvancedSettingsPage />} />}
				/>
				<Route path="/user-account" element={<PrivateRoute layout="AppLayout" element={<UserAccountPage />} />} />
			<Route path="/login" element={<LoginPage />} />
			<Route path="/register" element={<RegistrationPage />} />
			<Route path="/reset-password" element={<ResetPasswordPage />} />
			<Route path="/google-auth/login" element={<GoogleLoginPage />} />
			<Route path="/google-auth/callback" element={<GoogleCallbackPage />} />
			<Route path="/logout" element={<LogoutPage />} />
			<Route path="/terms" element={<TermsPage />} />
		</Routes>
	</BrowserRouter>
)
